import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Flex, Link as ChakraLink, mode, useColorMode } from '@abb/uikit';
import { ArrowNarrowLeft } from '@abb/uikit/icons/outline/arrow';
import { XClose } from '@abb/uikit/icons/outline/general';
import { useLoyaltyCheckMember } from 'hooks';
import { LoyaltyMemberStatus } from 'modules/Layout/models';
import React from 'react';
import { Link } from 'react-router-dom';
import { AbbLogo } from 'shared-components/abb-logo';
import { Point } from '../FaydaPoint';
export const HeaderResponsive = (param)=>{
    let { onCloseSidebar, responsiveOpenModal, responsiveSetOpenModal } = param;
    const { colorMode } = useColorMode();
    const { data } = useLoyaltyCheckMember();
    const shouldDisplayPointStatuses = [
        LoyaltyMemberStatus.ACTIVE_MEMBER,
        LoyaltyMemberStatus.FROZEN_ACTIVE_MEMBER,
        LoyaltyMemberStatus.INACTIVE_MEMBER
    ];
    return /*#__PURE__*/ _jsxs(Flex, {
        bg: mode('#F0F0F0', '#0A0B0D')({
            colorMode
        }),
        justifyContent: "space-between",
        p: 4,
        alignItems: "center",
        width: "100%",
        children: [
            !!responsiveOpenModal ? /*#__PURE__*/ _jsx(Flex, {
                border: `1px solid ${mode('#0A0B0D14', '#ffffff14')({
                    colorMode
                })}`,
                borderRadius: "99px",
                p: "8px",
                onClick: ()=>responsiveSetOpenModal(!responsiveOpenModal),
                cursor: "pointer",
                alignItems: "center",
                justifyContent: "center",
                children: /*#__PURE__*/ _jsx(ArrowNarrowLeft, {
                    w: "16px",
                    h: "16px"
                })
            }) : /*#__PURE__*/ _jsx(ChakraLink, {
                as: Link,
                textAlign: "left",
                to: "/dashboard",
                pl: {
                    base: 0,
                    md: '20px'
                },
                mb: {
                    base: 0,
                    md: '36px'
                },
                mt: {
                    base: 0,
                    md: '24px'
                },
                display: "block",
                children: /*#__PURE__*/ _jsx(AbbLogo, {})
            }),
            /*#__PURE__*/ _jsxs(Flex, {
                alignItems: "center",
                children: [
                    /*#__PURE__*/ _jsx(Box, {
                        borderRight: `1px solid ${mode('#0A0B0D14', '#ffffff14')({
                            colorMode
                        })}`,
                        pr: 3,
                        children: (shouldDisplayPointStatuses === null || shouldDisplayPointStatuses === void 0 ? void 0 : shouldDisplayPointStatuses.includes(data)) && /*#__PURE__*/ _jsx(Point, {
                            loyaltyStatus: data
                        })
                    }),
                    /*#__PURE__*/ _jsx(Flex, {
                        border: `1px solid ${mode('#0A0B0D14', '#ffffff14')({
                            colorMode
                        })}`,
                        borderRadius: "99px",
                        p: "8px",
                        onClick: onCloseSidebar,
                        cursor: "pointer",
                        alignItems: "center",
                        justifyContent: "center",
                        children: /*#__PURE__*/ _jsx(XClose, {
                            w: "16px",
                            h: "16px"
                        })
                    })
                ]
            })
        ]
    });
};
